import { semvApi } from "../axios/apis.service";

import { ILayers } from "../../interfaces/ILayers";
import { IPaginateApiResponse } from "../../interfaces/IPaginate";
import { DynamicInput } from "../../../components/page-releated/home/serach-any-layer/SearchAnyForm";

export const LayersApiService = {
    async getLayers(
        searchParms?: string,
        relations?: string
    ): Promise<IPaginateApiResponse<ILayers[]>> {
        const { data } = await semvApi
            .get(`/layers?${searchParms}${relations}`)
            .catch(() => ({ data: { data: [] } }));

        return data;
    },
    async getTableLayers(searchParms?: string): Promise<DynamicInput[]> {
        // console.log(`/layers-tables/${searchParms}`);
        const { data } = await semvApi
            .get(`/layers-tables/${searchParms}`)
            .catch(() => ({ data: { data: [] } }));

        return data;
    },
    async getTableDataLayers(
        searchParms?: string,
        relations?: string
    ): Promise<IPaginateApiResponse<Record<string, string | number>[]>> {
        // console.log(`/layers-tables/${searchParms}?${relations}`);
        const { data } = await semvApi
            .get(`/layers-tables-data/${searchParms}?${relations}`)
            .catch(() => ({ data: { data: [] } }));
        // console.log(data);
        return data;
    },
};
